import TestimonialsDataFa from "./TestimonialsData-fa.json";
import TestimonialsDataEn from "./TestimonialsData-en.json";
import TestimonialsDataAr from "./TestimonialsData-ar.json";
import TestimonialsDataTr from "./TestimonialsData-tr.json";

export const dataLocales = {
    fa: {
        testimonialsData: TestimonialsDataFa,
    },
    en: {
        testimonialsData: TestimonialsDataEn,
    },
    ar: {
        testimonialsData: TestimonialsDataAr,
    },
    tr: {
        testimonialsData: TestimonialsDataTr,
    },
};